module.exports = __webpack_public_path__ + "img/pagseguro-logo.45a77346.png";